import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const DateDialog = ({
    open,
    onClose,
    onSave,
    defualtDate,
    saveLabel,
    title,
}) => {
    const { t } = useTranslation();
    const [value, setValue] = useState(defualtDate);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <TextField
                    type="datetime-local"
                    defaultValue={defualtDate}
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    sx={{ width: 240 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={e => onSave(value)}>
                    {saveLabel || t('Confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DateDialog;
